import { gql } from '@apollo/client';

export const orderTriplePlayV2 = gql`
  mutation AddTriplePlayOrder($orderInput: TriplePlay_OrderV2Input!) {
    addTriplePlayOrderV2(orderInput: $orderInput) {
      orderId
      errors
    }
  }
`;

export const orderTriplePlay = gql`
  mutation orderTriplePlay(
    $policyPolicyDetailsRequest: [PolicyDetailsInput!]
    $chosenProductKrn: String!
    $comparisonId: String!
    $frontEndName: String
    $clientId: String!
    $googleAnalyticsId: String
    $googleAnalyticsSessionId: String
  ) {
    orderTriplePlay(
      input: {
        request: {
          commonTechnical: {
            sessionId: "5a2665d0-6d61-4f25-9be5-6750a3c9cdc0"
            senderId: $clientId
            googleAnalyticsId: $googleAnalyticsId
            googleAnalyticsSessionId: $googleAnalyticsSessionId
          }
          policyPolicyDetails: $policyPolicyDetailsRequest
        }
        chosenProductKrn: $chosenProductKrn
        comparisonId: $comparisonId
        frontEndName: $frontEndName
      }
    ) {
      orderResult {
        orderId
      }
    }
  }
`;
